import axios from "axios";
import switchAPI from "./switchAPI";

axios.defaults.withCredentials = true;

export const searchCenterNameAPI = `${switchAPI}/search/center-name`;
export const searchCenterLocationAPI = `${switchAPI}/search/center-location`;